import { useState } from "react";
import { getVideoEmbedUrl } from "@/lib/videoEmbed";

interface VideoEmbedProps {
  url: string;
  title?: string;
}

export const VideoEmbed = ({ url, title = "Speaker Video" }: VideoEmbedProps) => {
  const [isLoading, setIsLoading] = useState(true);

  const embedUrl = getVideoEmbedUrl(url);

  if (!embedUrl) {
    return (
      <div className="bg-muted/30 rounded-lg p-8 text-center">
        <p className="text-muted-foreground">Invalid video URL. Please provide a valid YouTube or Vimeo URL.</p>
      </div>
    );
  }

  return (
    <div className="relative w-full aspect-video rounded-lg overflow-hidden bg-black">
      {isLoading && (
        <div className="absolute inset-0 flex items-center justify-center bg-muted/50 z-10">
          <div className="text-center">
            <div className="w-8 h-8 border-2 border-primary border-t-transparent rounded-full animate-spin mx-auto mb-2"></div>
            <p className="text-sm text-muted-foreground">Loading video...</p>
          </div>
        </div>
      )}
      <iframe
        src={embedUrl}
        title={title}
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
        className="w-full h-full"
        onLoad={() => setIsLoading(false)}
      />
    </div>
  );
};
